<template>
  <div id="app">
    <Top></Top>
    <div class="content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>

    <Footer></Footer>

    <ScrollToTop>
      <b-button pill class="btn btn-circle blue-bg btn-md">
        <i class="material-icons arrow">arrow_upward</i>
      </b-button>
    </ScrollToTop>
  </div>
</template>


<script>
import Top from "./components/Top";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

export default {
  name: "App",
  components: {
    Top,
    Footer,
    ScrollToTop,
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
@import "./styles/variables.scss";
@import url("https://fonts.googleapis.com/css2?family=Rubik+Glitch&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Barlow&family=Rubik+Glitch&display=swap");

@media screen and (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.001ms !important;
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
  }
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: Verdana, Geneva, sans-serif !important;
}

.bg-purple {
  background-color: $purple;
}
.bg-green {
  background-color: $green;
}
.path {
  background: url("./SVG-filer/PNG-path1-1.png");
  background-repeat: repeat-y;
}

@media screen and (max-width: 1200px) {
  .path {
    background-size: 100%;
  }
}
@media screen and (max-width: 767px) {
  .path {
    background-size: 150%;
  }
}
@media screen and (max-width: 375px) {
  .path {
    background-size: 175%;
  }
}

.pattern {
  background: url("https://res.cloudinary.com/oredev/image/upload/q_auto,f_auto,c_crop,w_1230/v1649052515/2022_web/pattern4.png");
}

.pattern2 {
  background: url("https://res.cloudinary.com/oredev/image/upload/q_auto/v1648817555/2022_web/pattern2.png");
}

.bg-grey-light {
  background-color: $grey-light;
}
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.2s;
}
.fade-leave-to {
  opacity: 0;
}

.fade-leave-active {
  transition: opacity 0.2s;
}

body {
  font-size: 1rem !important;
  background-color: white !important;
  color: $text-dark !important;
}

.modal-header {
  color: $text-color-light !important;
  background-color: $bg-dark !important;
}
.modal-header button {
  color: $green !important;
}
.modal-title {
  color: $text-color-light !important;
  background-color: $bg-dark !important;
}
.modal-body {
  color: $text-color-light !important;
  background-color: $bg-dark !important;
}

.bg-color-dark {
  background-color: $bg-dark !important;
}
.text-dark {
  color: $text-dark !important;
}
.text-color-light {
  color: $text-color-light !important;
}
.pink {
  color: $pink !important;
}
.green {
  color: $green !important;
}
.green-bg {
  background: $green !important;
}
.green-light-bg {
  background: $green-light !important;
}
.purple-light-bg {
  background: $pink !important;
}
.orange {
  color: $orange !important;
}
.orange-bg {
  background-color: $orange !important;
}
.red {
  color: $red !important;
}
.red-bg {
  background-color: $red !important;
}

h1,
h2,
h3,
h4,
h5 {
  font-family: "Rubik Glitch", cursive;
}

h1 {
  color: $pink;
  @media (max-width: 767px) {
    font-size: 1.6rem !important;
  }
  @media (max-width: 576px) {
    font-size: 1.4rem !important;
  }
}

.big-headline {
  font-size: 4rem;
  @media (max-width: 576px) {
    font-size: 2rem !important;
  }
}

h2 {
  @media screen and (max-width: 767px) {
    font-size: 1.4rem !important;
  }
  @media screen and (max-width: 576px) {
    font-size: 1.2rem !important;
  }
}

h3 {
  @media (max-width: 767px) {
    font-size: 1.2rem !important;
  }
  @media (max-width: 576px) {
    font-size: 1.1rem !important;
  }
}
h4 {
  @media (max-width: 767px) {
    font-size: 1.1rem !important;
  }
  @media (max-width: 576px) {
    font-size: 1rem !important;
  }
}
h5 {
  @media (max-width: 767px) {
    font-size: 1rem !important;
  }
  @media (max-width: 576px) {
    font-size: 0.8rem !important;
  }
}
p,
a,
li,
span,
.btn {
  @media (max-width: 767px) {
    font-size: 0.9rem !important;
  }
}

.hidden {
  display: none !important;
}
a,
a:visited {
  color: $orange !important;
  text-decoration: underline !important;
  font-weight: 700;
}

a.text-white {
  color: #fff !important;
}
.btn {
  cursor: pointer;
  font-weight: 700;
}
.btn-lg {
  padding: 20px;
}

/*================ MENU ===============*/
nav {
  // background: #fff;
  opacity: 0.75;
  @media (max-width: 991px) {
    opacity: 1;
    border-bottom: 1px solid #ddd;
  }
}
a.nav-link {
  // text-transform: uppercase;
  // font-weight: bold;
  color: $text-dark !important;
  text-decoration: none !important;
  margin-left: 30px;
}
a.nav-link:hover {
  color: $orange !important;
  text-decoration: underline !important;
}

.navbar-brand.router-link-exact-active {
  fill: $pink;
}
a.router-link-exact-active {
  fill: $orange !important;
  text-decoration: underline !important;
}
a.router-link-active {
  color: $orange !important;
  text-decoration: underline !important;
}
/*================ MENU END ===============*/
/*================ TAGS ===============*/
.tags-container .select {
  text-transform: uppercase;
  color: $green;
  cursor: pointer;
}

.tags-container .tags {
  margin: 0 0 2rem 0;
}
.tags-container .tags .col-xs-6 {
  @media (max-width: 576px) {
    width: 50%;
  }
}
.tag {
  font-size: 1rem;
  margin: 2px -13px;
  border: 2px solid $grey-light;
  height: 4em;
  opacity: 0.5;

  //line-height: 3em;
  text-transform: uppercase;
  padding: 10px 10px;
  cursor: pointer;
  @media (max-width: 992px) {
    font-size: 0.9rem;
  }
  @media (max-width: 576px) {
    font-size: 0.8rem;
  }
}
.tag:hover {
  background-image: linear-gradient(rgba(0, 0, 0, 0.1) 0 0);
}
.tags-add:hover {
  background-image: linear-gradient(rgba(0, 0, 0, 0.1) 0 0);
}
.tag-choosen:hover {
  background-image: linear-gradient(rgba(0, 0, 0, 0.1) 0 0);
}
.tags-container .select-all {
  @media (max-width: 576px) {
    margin-top: 0;
  }
}
.tags-container .select-all span {
  text-transform: uppercase;
  margin: 0 10px;
}
.tag.active,
.tag-choosen.active {
  background-color: $pink;
  opacity: 1;
}
.tag-choosen.active.speaker {
  background-color: $pink;
  color: #fff;
}
.tag-choosen {
  white-space: nowrap;
  display: inline-block;
  border: 1px solid #000;
  height: 45px;
  padding: 10px 5px 10px 20px;
  text-transform: uppercase;
  width: auto;
  margin: 0 2px 2px 0;
  z-index: 99;
  cursor: pointer;
  @media (max-width: 992px) {
    padding: 7px 10px 7px 10px;
    height: 40px;
  }
  @media (max-width: 576px) {
    padding: 4px 10px 4px 10px;
    height: 35px;
  }
  color: $text-color-light;
  background-color: $bg-dark;
  opacity: 0.5;
}
.tag-choosen,
.tags-add {
  font-size: 1rem;
}
.tag-choosen span {
  margin: 0 10px 0 0;
  @media (max-width: 991px) {
    font-size: 0.9rem;
  }
  @media (max-width: 576px) {
    font-size: 0.8rem;
    margin: 0 4px 0 0;
  }
}
.tag-choosen i {
  font-size: 1rem;
  vertical-align: middle;
  @media (max-width: 991px) {
    font-size: 0.9rem;
  }
  @media (max-width: 576px) {
    font-size: 0.8rem;
  }
}
.tags-add i {
  vertical-align: middle;
}
.tags-add {
  display: inline-block;
  border: 1px solid rgba(0, 128, 0, 0);
  width: 44px;
  height: 44px;
  margin-bottom: 3px;
  padding: 10px;
  background-color: $green;
  color: #fff;
  cursor: pointer;
  /*   @media (max-width: 991px) {
    padding: 7px;
    height: 39px;
    width: 39px;
  }
  @media (max-width: 576px) {
    padding: 4px;
    height: 34px;
    width: 34px;
  } */
}
.loading-tags {
  margin: 10rem 0 60rem 0;
}
.tags-container .confirm-tags {
  margin: 1rem 0 60rem 0;
}
.btn.btn-circle.disabled {
  background-color: $grey-light !important;
}
.btn.btn-circle {
  background-color: $green !important;
  width: 100px;
  height: 100px;
  text-align: center;
  padding: 20px 0;
  font-size: 40px;
  font-weight: bold;
  line-height: 1.428571429;
  border-radius: 50%;
  cursor: pointer;
}
.btn-circle .material-icons {
  color: #fff;
  font-weight: bold;
  font-size: 50px;
}
/*=================== TAGS END ==================*/
/*=================== SESSIONS ==================*/
.session .add-schedule {
  cursor: pointer;
}
.session.active .add-schedule i,
.session.active .time {
  color: $pink;
}
.session.active .add-schedule i.remove {
  display: inline-block;
}
.session.active .add-schedule i.add {
  display: none;
}
.session .add-schedule i.remove {
  display: none;
}
.session .add-schedule i.add {
  display: inline-block;
}

.session {
  margin: 0 0 1em 0;
  background-color: $text-color-light;
  color: black;
}
.sessions-container .sessions {
  margin-bottom: 8rem;
}
.session .add-schedule i {
  padding-top: 15px;
}
.session .time h2 {
  font-size: 3.7rem;
  @media (max-width: 1199px) {
    font-size: 2.9rem;
    padding-top: 10px;
  }
  @media (max-width: 991px) {
    font-size: 2rem;
    padding-top: 18px;
  }
  @media (max-width: 767px) {
    font-size: 2.4rem !important;
  }
}
.session .main {
  padding-top: 10px;
}

.session .fold-icons,
.session .session-title {
  display: inline-block;
}
.session .fold-icons {
  float: left;
  width: 3%;
  @media (max-width: 1199px) {
    width: 4%;
  }
  @media (max-width: 991px) {
    width: 5%;
  }
}
.session .session-title {
  width: 97%;
  display: inline-block;
  padding: 3px 0 0 10px;
  font-family: "Verdana";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  @media (max-width: 1199px) {
    width: 96%;
  }
  @media (max-width: 991px) {
    width: 90%;
  }
}

.session .session-info {
  margin-top: 5px;
  padding-top: 5px;
  border-top: 1px solid #555;
  margin-left: 15px;
  cursor: pointer;
}
.session .session-text {
  margin: 10px 0 0 0;
  @media (max-width: 576px) {
    font-size: 1rem;
  }
}
.session .speaker,
.session .room,
.session .material-icons {
  cursor: pointer;
  color: black;
}
.session .speaker,
.session .room {
  font-family: "Verdana";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}
.sessions-container .days {
  margin: 1em 0 3em 0 !important;
  @media (max-width: 576px) {
    margin-bottom: 0 !important;
  }
}
.sessions-container .days ul {
  padding: 0;
  list-style-type: none;
}

.sessions-container ul.conference,
.sessions-container ul.workshop {
  list-style: none;
  display: inline-block;
}
.sessions-container .conference li,
.sessions-container .workshop li {
  float: left;
  margin-right: 1em;
  text-transform: uppercase;
}
.sessions-container .days li {
  @media (max-width: 991px) {
    font-size: 1.2rem;
  }
  @media (max-width: 767px) {
    font-size: 1rem;
  }
  @media (max-width: 576px) {
    font-size: 0.7rem;
    margin-right: 0.1rem;
  }
}
.sessions-container .days li span {
  @media (max-width: 991px) {
    font-size: 1.5rem;
  }
  @media (max-width: 767px) {
    font-size: 1.2rem;
  }
  @media (max-width: 576px) {
    font-size: 0.9rem;
    margin-right: 0.5rem;
  }
}
.sessions-container .conference li.session-type,
.sessions-container .workshop li.session-type {
  clear: both;
  color: #888;
  border-top: 1px dotted #888;
  width: 100%;
}
/*=================== SESSIONS END==================*/
/*=================== LINE-UP ==================*/
.lineup .speaker-card {
  margin-bottom: 40px;
  z-index: 10;
}
.lineup .speaker-card .speaker-company {
  font-size: 11px;
  color: white;
}
.lineup .speaker-card .speaker-name {
  margin: 10px 0 0 0;
}
.speaker-single {
  margin-bottom: 150px;
  z-index: 10;
  position: relative;
}
.speaker-single h4 {
  margin-top: 20px;
}
.arrow {
  font-size: 2rem !important;
}

.btn {
  border: 0 !important;
  border-radius: 0 !important;
  background-color: white !important;
  border: 2px solid $orange !important;
  color: $orange !important;

  z-index: 99;
  font-weight: 700 !important;
}

.btn-1 {
  width: 165px !important;
  height: 42px !important;
}

.btn:hover {
  color: $text-color-light !important;
  background: $orange !important;
}
/*=================== LINE-UP END==================*/
.glitch {
  position: relative;
  color: #fff;
  font-size: 80px;
}

.line {
  font-family: "Rubik Glitch", cursive;

  &:not(:first-child) {
    position: absolute;
    top: 0;
    left: 0;
  }

  @for $i from 1 through 10 {
    &:nth-child(#{$i}) {
      animation: clip 3000ms $i * -300ms linear infinite,
        glitch#{$i} 1000ms random(1000) * -1ms linear infinite; //500 ms before

      @keyframes glitch#{$i} {
        0% {
          transform: translateX(0);
        }
        80% {
          transform: translateX(0);
          color: #292929;
        }
        85% {
          transform: translateX(random(10) - 5px);
          color: #4e9a26;
        }
        90% {
          transform: translateX(random(10) - 5px);
          color: #ac1212;
        }
        95% {
          transform: translateX(random(10) - 5px);
          color: #292929;
        }
        100% {
          transform: translateX(0);
        }
      }
    }
  }
}

@keyframes clip {
  0% {
    clip-path: polygon(0 100%, 100% 100%, 100% 120%, 0 120%);
  }

  100% {
    clip-path: polygon(0 -20%, 100% -20%, 100% 0%, 0 0);
  }
}
.grecaptcha-badge {
  visibility: hidden !important;
}

.p-margin-bottom {
  margin-bottom: 25px;
}
.headline-margin-top {
  margin-top: 60px;
}

.disabled-all {
  opacity: 0.5;
  cursor: default;
}

.disabled-all:hover {
  background-image: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue